/**
 * BILDIRIM OLAYLARININ OKUNABILIR KARSILIGI — F-NTF-09
 *
 * ================================================================
 * NEDEN VAR
 * ================================================================
 * Bildirimin `eventCode` alani makine icin yazilmis:
 * `ProgramYayinlandi`, `MemnuniyetAnketiGonderildi`. Gelen kutusunun
 * "olay turu" suzgecinde bu kodu gostermek, kullaniciya kendi
 * bildirimlerini AYIKLAYAMADIGI bir liste vermek olurdu.
 *
 * ================================================================
 * NEDEN SOZLESME PAKETINDE
 * ================================================================
 * Ayni gelen kutusu IKI uygulamada birden var (F-NTF-09: *"Ayni gelen
 * kutusu ogrenci uygulamasinda da vardir"*). Sozluk panelde yazildigi
 * yerde kalsaydi, ogrenci uygulamasi ikinci bir kopya tasirdi ve yeni
 * bir olay eklendiginde biri guncellenip oteki geride kalirdi —
 * `BASLA.md`'nin "ayni kural iki yerde" sinifi.
 *
 * Katalogun KENDISI burada DEGIL: o `apps/api/src/modules/bildirim/
 * bildirim-kural.ts` icinde ve orasi Prisma'ya bagli. Panel ve ogrenci
 * uygulamasi oraya bagimli olamaz — `olay-metni.ts` ile birebir ayni
 * gerekce ve birebir ayni bedel: katalog iki dosyada yasiyor.
 *
 * Bedeli `bildirim-olayi.test.ts` olcuyor: sozlukte olmayan bir olay
 * kodu ya da katalogda karsiligi kalmamis bir sozluk girdisi testi
 * DUSURUR.
 */

const BILDIRIM_OLAY_ADI = {
  // --- Program ------------------------------------------------------
  ProgramYayinlandi: "Program yayınlandı",
  ProgramRevizeEdildi: "Program revize edildi",
  ProgramDegisiklikTalebi: "Program değişikliği istendi",
  ProgramDegisiklikSonucu: "Program değişikliğine karar verildi",
  GorevGecikti: "Görev gecikti",
  VeriGirisiEksik: "Veri girişi eksik",

  // --- Deneme -------------------------------------------------------
  DenemeYaklasti: "Deneme yaklaştı",
  // F-EXM-17/24 — panel içi deneme olayları gelen kutusunda da anlaşılır olmalı.
  DenemeAtandi: "Deneme atandı",
  DenemeNetiGuncellendi: "Deneme neti güncellendi",
  DenemeDuzeltmeBekliyor: "Deneme sonucu düzeltme bekliyor",
  DenemeSonucuHazir: "Deneme sonucu hazır",

  // --- Mentorum -----------------------------------------------------
  // F-MNT-14 — ad içerik taşımaz; yalnız yöneticinin gelen kutusunda görünür.
  MentorumRiskUyarisi: "Mentörüm risk uyarısı",
  MentorumRiskHatirlatmasi: "Kapanmamış Mentörüm risk uyarısı",

  // --- Gorusme ------------------------------------------------------
  GorusmeHatirlatma: "Görüşme hatırlatması",
  GorusmeYenidenPlanlandi: "Görüşme yeniden planlandı",
  GorusmeRaporuEksik: "Görüşme raporu eksik",

  // --- Ogrenci ve uzman ---------------------------------------------
  VeliRaporuYayinlandi: "Gelişim raporu yayınlandı",
  UzmanDegisti: "Uzman değişti",
  OgrenciPasiflesti: "Öğrenci pasifleşti",

  // --- Hesap ve guvenlik --------------------------------------------
  /*
    "Hesabıma" DEĞİL "Hesabınıza": bu sözlük hem öğrenciye (sen) hem
    veliye (siz) görünüyor ve iki kip için iki sözlük tutmak, olay
    eklendiğinde ikisini birden yazmayı zorunlu kılardı. İyelik eki
    olmayan cümle her iki kipte de doğru okunuyor.
  */
  YeniCihazGirisi: "Yeni bir cihazdan giriş yapıldı",
  HesabinizinGorunumuneGecildi: "Hesap görünümüne geçildi",

  // --- Onay ---------------------------------------------------------
  OnayIstendi: "Onay istendi",
  OnayKarariVerildi: "Onay talebine karar verildi",

  // --- Finans -------------------------------------------------------
  OdemeVadesiYaklasti: "Ödeme vadesi yaklaştı",
  PaketBitiyor: "Paket bitiyor",
  FaturaKesildi: "Fatura kesildi",
  FaturaHatasi: "Fatura kesilemedi",

  // --- Satis --------------------------------------------------------
  YeniBasvuru: "Yeni başvuru geldi",

  // --- Anket --------------------------------------------------------
  MemnuniyetAnketiGonderildi: "Memnuniyet anketi gönderildi",
  AnketDusukPuan: "Ankette dikkat gerektiren yanıt",

  // --- Destek -------------------------------------------------------
  DestekTalebiAcildi: "Destek talebi açıldı",
  DestekTalebiCevaplandi: "Destek talebi cevaplandı",

  // --- Takvim -------------------------------------------------------
  TakvimCakismasi: "Takvimde çakışma var",
  TakvimSenkronHatasi: "Takvim eşitlenemedi",

  // --- KVKK ---------------------------------------------------------
  MuvafakatEksik: "Veli muvafakatı bekleniyor",

  // --- Güvenlik izleme (G-IZL-02) -----------------------------------
  GuvenlikUyarisi: "Güvenlik uyarısı tetiklendi",

  // --- Duyuru (F-NTF-08b) -------------------------------------------
  DuyuruYayinlandi: "Koç duyurusu yayınlandı",

  // --- Oyunlaştırma (F-GAM-14) --------------------------------------
  PuanSuresiDoluyor: "Puanlarının süresi dolmak üzere",

  // --- Ödül mağazası (F-GAM-16) -------------------------------------
  OdulOnayiBekliyor: "Ödül talebi onayınızı bekliyor",
  OdulAdresiBekliyor: "Ödül siparişin için adres bekleniyor",
  OdulSiparisiGuncellendi: "Ödül siparişinde gelişme var",
} as const;

export type BildirimOlayKodu = keyof typeof BILDIRIM_OLAY_ADI;

/**
 * Olay kodunun okunabilir karsiligi.
 *
 * ================================================================
 * TANINMAYAN KOD HAM KOD OLARAK GORUNMEZ — AMA AYIRT EDILEBILIR
 * ================================================================
 * Katalog buyuyebilir ve bu paket API'den ayri dagitiliyor: yeni bir
 * olayla yazilmis bir bildirim, sozluk henuz guncellenmeden ekrana
 * dusebilir. Bos dizgi donseydi o bildirimin turu suzgecte ADSIZ bir
 * secenek olur, kullanici da onu hic suzemezdi. Ham PascalCase kod ise
 * (`OdemeVadesiYaklasti`) kullaniciya makine dili gosterirdi.
 *
 * Cozum: "Diger bildirim (Odeme Vadesi Yaklasti)" — anlasilir bir
 * cerceve + kodun bosluklarla ayrilmis hali, yani hem okunur hem
 * birbirinden ayirt edilir. Bos kod icin yalnizca cerceve doner.
 */
export function bildirimOlayAdi(kod: string): string {
  const bilinen = (BILDIRIM_OLAY_ADI as Record<string, string>)[kod];
  if (bilinen !== undefined) return bilinen;
  const ayrik = kod
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .trim();
  return ayrik === "" ? "Diğer bildirim" : `Diğer bildirim (${ayrik})`;
}

export const BILDIRIM_OLAY_ADI_SOZLUGU: Readonly<Record<BildirimOlayKodu, string>> =
  BILDIRIM_OLAY_ADI;
